import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as selectors from '../sample.selectors';
import * as sampleActions from '../sample.actions';
import * as applicationSelectors from '../../../application.selectors'
import {PageSection, WarningButton} from '../../../components/index'
import {SampleDataGrid} from "../components/index";
import {PrimaryButton} from "../../../components";
import {withRouter} from "react-router-dom";

const RecordActions = history => ({data: {recordStatusValue, periodId, id}}) =>
  recordStatusValue >= 3 ?
    <PrimaryButton onClick={() => history.push(`/records/${periodId}/${id}/uploads`)}>View</PrimaryButton> :
    <WarningButton onClick={() => history.push(`/records/${periodId}/${id}/uploads`)}>Upload</WarningButton>;

class SampleContainer extends React.Component {

  componentWillMount() {
    const {actions: {setFilters}, facility} = this.props;
    setFilters({facility: facility.id});
  }

  componentWillUpdate(nextProps) {
    const {actions: {setFilters}, facility} = this.props;
    if (facility !== nextProps.facility) {
      setFilters({facility: nextProps.facility.id});
    }
  }

  render() {
    const {patients, facilityFilter} = this.props;

    //ensure the filter has been set before showing records.
    const patientData = facilityFilter ? patients : [];

    return (
      <PageSection>
        <SampleDataGrid
          patients={patientData}
          actionsRenderer={RecordActions(this.props.history)}
        />
      </PageSection>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      period: selectors.currentPeriod(state),
      patients: selectors.includedPatients(state),
      facilityFilter: selectors.facilityFilter(state),
      facility: applicationSelectors.userFacility(state),
    }),
    dispatch => ({
      actions: bindActionCreators({
        ...sampleActions
      }, dispatch)
    })
  )(SampleContainer)
);



// WEBPACK FOOTER //
// ./src/modules/sample/nursing-facility/index.js